import { observable, runInAction } from "mobx"

import { withGlobalLoader } from "@/lib/context.ts"
import { getLogger } from "@/lib/logging.ts"

import type {
  BranchInfo,
  ProjectKey,
  RepositoryFetchStatus,
  WarmupInfo
} from "@/lib/client/generated/TypeDefinitions.ts"
import type { OrgContext } from "@/lib/context.ts"
import type { Lifetime } from "@/lib/Lifetime.ts"

const log = getLogger("BranchSelection")

export class BranchSelection {
  constructor(
    readonly context: OrgContext,
    readonly lifetime: Lifetime,
    readonly projectKey: ProjectKey,
    readonly repositoryName: string,
  ) {
    void this.loadWarmupInfo()
    void this.subscribeToRepoSyncStatus()
  }

  readonly selectedBaseBranch = observable.box<BranchInfo | null>(null)

  readonly warmupInfo = observable.box<WarmupInfo | null>(null)

  readonly repoSyncStatus = observable.box<RepositoryFetchStatus | null>(null)

  async loadWarmupInfo() {

    try {
      const info = await withGlobalLoader(this.context, this.context.queries.getWarmupInfo(this.projectKey, this.repositoryName))

      runInAction(() => {
        this.warmupInfo.set(info)
      })
    } catch (e) {
      const msg = "Failed to load warmup info:"
      log.error(msg, e)
    }
  }

  private async subscribeToRepoSyncStatus() {
    try {
      const subscription = await this.context.queries.subscribeToRepositorySyncErrors(this.projectKey, this.repositoryName)
      runInAction(() => {
        this.repoSyncStatus.set(subscription.initial)
      })

      const channel = subscription.channel
      this.lifetime.add(channel.subscribe(status => {
        runInAction(() => this.repoSyncStatus.set(status))
      }), "BranchSelection:subscribeToRepoSyncStatus")
    } catch (e) {
      log.error("Failed to subscribe to repo sync status:", e)
    }
  }

}